import type { FoxKifuRecordData, StoneColor } from '@wx-weiqi/contracts';
import { classroomRecordHistory, type ClassroomFrame } from './classroom-lecture';

/** Build display frames and retain the server replay prefix for subsequent rule checks. */
export function classroomReplayFrames(
  loaded: FoxKifuRecordData,
  initialPlayer: StoneColor,
  sharedFrames: readonly ClassroomFrame[] = [],
): readonly ClassroomFrame[] {
  const opening = sharedFrames[0] ?? loaded.frames[0];
  if (opening === undefined) throw new Error('SGF opening is missing');
  const prefix: Array<{ color: StoneColor; point: { x: number; y: number } | null }> = [
    ...(sharedFrames.at(-1)?.ruleHistory?.request.history ?? []),
  ];
  return Object.freeze([
    ...sharedFrames,
    ...loaded.frames.map((frame) => {
      if (frame.color !== null && frame.kind !== 'OPENING') {
        prefix.push({ color: frame.color, point: frame.kind === 'PASS' ? null : frame.point });
      }
      return Object.freeze({
        moveNumber: frame.moveNumber,
        stones: frame.stones,
        lastMove: frame.kind === 'PLAY' ? frame.point : null,
        color: frame.kind === 'PLAY' ? frame.color : null,
        ruleHistory: classroomRecordHistory(
          loaded.record.boardSize,
          opening.stones,
          initialPlayer,
          [...prefix],
        ),
      });
    }),
  ]);
}
